import React, { useEffect, useState, useRef, Fragment } from 'react'
import { Body, Content, ContainerBoxMsg, UserMessage, BotMessage, Wrapper, BtnOption, UserOption, BoxOptions, BotMessageConfirmation, Main } from './styles'
import BtnChat from '../BtnChat'
import Loading from './Loading'
import logoTransparent from '../../assets/images/logotransparent.png'
import { toast, Bounce } from '../../Components'
import Header from './Header'
import BoxInput from './BoxInput'
import { formatCnpj, formatTelefone } from '../../helpers/util'
import ConfirmationMessage from './AnimationConfirmationMessage'
const initValues = { conversaId: 0, msgIndex: 0, mensagens: '[]' }

export default function App() {
  const pageEndRef = useRef()
  const [isOpen, setIsOpen] = useState(false)
  const [isLoading, setLoading] = useState(false)
  const [values, setValues] = useState(initValues)
  const [conversation, setConversation] = useState()
  const URL_BASE = 'https://chatbot-api.lactec.com.br/api'

  useEffect(() => {
    if (isOpen && !conversation) onSubmit(values)
  }, [isOpen])

  useEffect(() => {
    if (conversation) setValues({ ...values, mensagens: JSON.stringify(conversation) })

    scrollToBottom()
  }, [conversation])
  function uuidv4() {
    return '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, (c) => (+c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (+c / 4)))).toString(16))
  }

  function onGoHome() {
    setValues(initValues)
    setConversation()
    setIsOpen(false)

    setTimeout(function () {
      setIsOpen(true)
    }, 500)
  }

  async function onSubmit(_values) {
    setLoading(true)
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(_values),
    }

    const delayDebounceFn = setTimeout(() => {
      const fetchMessages = async () => {
        try {
          const response = await fetch(`${URL_BASE}/Conversa/AddMsg`, requestOptions)
          const data = await response.json()

          if (!data.result) {
            toast('Ops, ocorreu um problema, utilize outro canal', { type: 'error', transition: Bounce, closeButton: true, autoClose: 5000, position: 'top-right' })
            return
          }
          setValues({ ...values, conversaId: data.conversaId, msgIndex: values.msgIndex + 1 })
          // var currentTime = new Date().getTime()
          // while (currentTime + 1500 >= new Date().getTime()) {}

          let _mensagens = []
          data.mensagens.forEach((d) => {
            _mensagens.push({ ...d, mensagemId: uuidv4() })
          })

          setConversation((prevConversation) => {
            if (prevConversation?.length > 0) return [...prevConversation, ..._mensagens]
            else return _mensagens
          })

          setLoading(false)
        } catch {
          setLoading(false)
        }
      }

      fetchMessages()
    }, 1000)
    return () => {
      clearTimeout(delayDebounceFn)
    }
  }

  function LoadTpServico() {
    const tpServico = conversation?.length >= 2 && conversation[1]?.conteudo
    return tpServico
  }

  function LoadLaboratorySelected() {
    const selectedLaboratory = conversation?.length >= 2 && conversation[3]?.conteudo
    return selectedLaboratory
  }

  async function onSelect(index) {
    let _conversation = []

    for (let index = 0; index < conversation.length - 1; index++) {
      _conversation.push({ ...conversation[index], mensagemId: uuidv4() })
    }

    let _item = conversation[conversation.length - 1]
    _item.conteudo = { ..._item.conteudo[index], selected: true }
    _item.fromMe = false
    _conversation.push(_item)
    setConversation(_conversation)

    onSubmit({ ...values, conteudo: _item.conteudo.value, mensagens: JSON.stringify(_conversation) })

    scrollToBottom()
  }

  function sendMessage(messageContent) {
    setLoading(true)
    let formattedContent = messageContent
    if ((LoadTpServico().value == 1 && values.msgIndex == 7) || (LoadTpServico().value == 2 && values.msgIndex == 5)) {
      formattedContent = formatCnpj(messageContent)
    } else if ((LoadTpServico().value == 1 && values.msgIndex == 8) || (LoadTpServico().value == 2 && values.msgIndex == 6)) {
      formattedContent = formatTelefone(messageContent)
    }
    let _conversation = [...conversation]
    _conversation.push({
      fromMe: false,
      tpConteudo: 'T',
      conteudo: formattedContent,
      mensagemId: uuidv4(),
    })

    setConversation(_conversation)
    onSubmit({ ...values, conteudo: messageContent, mensagens: JSON.stringify(_conversation) })

    scrollToBottom()
  }

  function sendMessageSelect(messageContent, options) {
    setLoading(true)
    let _conversation = [...conversation]
    const selectedOption = options.find((opt) => opt.value === messageContent)
    const label = selectedOption ? selectedOption.label : messageContent
    _conversation.push({
      fromMe: false,
      tpConteudo: 'T',
      conteudo: label,
      mensagemId: uuidv4(),
    })

    setConversation(_conversation)
    onSubmit({ ...values, conteudo: messageContent, mensagens: JSON.stringify(_conversation) })
  }

  function scrollToBottom() {
    pageEndRef.current?.scrollIntoView({ behavior: 'smooth' })
  }

  function formattedContent(conteudo) {
    let _conteudo = conteudo

    _conteudo = _conteudo.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
    _conteudo = _conteudo.replace('\n', '<br />')

    return _conteudo
  }
  function renderMessages() {
    if (conversation?.length > 0) {
      const listItems = conversation.map((msg, index) => {
        if (msg.fromMe) {
          return (
            <Fragment key={msg.mensagemId}>
              {msg.tpConteudo === 'O' ? (
                <BoxOptions>
                  {msg.conteudo.map((opt, optInd) => (
                    <BtnOption key={`opt_${index}_${opt.value}`} onClick={() => onSelect(optInd)}>
                      {opt.label}
                    </BtnOption>
                  ))}
                </BoxOptions>
              ) : msg.tpConteudo === 'E' ? (
                <>
                  <ContainerBoxMsg key={index} type={'bot'}>
                    <BotMessageConfirmation>
                      <p key={`mee_${index}`}>
                        <span dangerouslySetInnerHTML={{ __html: formattedContent(msg.conteudo) }}></span>
                        <ConfirmationMessage isVisible={true} />
                      </p>

                      <img src={logoTransparent} alt="Logo" />
                    </BotMessageConfirmation>
                  </ContainerBoxMsg>
                  <BoxOptions style={{ display: 'flex', marginLeft: '60px' }} onClick={onGoHome}>
                    <BtnOption>Voltar ao menu inicial</BtnOption>
                  </BoxOptions>
                </>
              ) : (
                <ContainerBoxMsg key={`me__${index}`} type={'bot'}>
                  <BotMessage>
                    <p dangerouslySetInnerHTML={{ __html: formattedContent(msg.conteudo) }}></p>
                    <img src={logoTransparent} alt="Logo" />
                  </BotMessage>
                </ContainerBoxMsg>
              )}
              {index == conversation?.length - 1 && renderPageRef(msg.mensagemId)}
            </Fragment>
          )
        } else {
          return (
            <Fragment key={msg.mensagemId}>
              <ContainerBoxMsg type={'user'}>
                <UserMessage>
                  {msg.tpConteudo === 'O' ? (
                    <UserOption>{msg.conteudo.label}</UserOption>
                  ) : (
                    <p>
                      {msg.conteudo.split('\n').map((line, i) => (
                        <span key={`u_${msg.mensagemId}_${i}`}>
                          {line}
                          <br />
                        </span>
                      ))}
                    </p>
                  )}
                </UserMessage>
              </ContainerBoxMsg>

              {isLoading && index == conversation?.length - 1 && renderLoading()}

              {index == conversation?.length - 1 && renderPageRef(msg.mensagemId)}
            </Fragment>
          )
        }
      })

      return listItems
    }
  }

  function renderLoading() {
    return (
      <ContainerBoxMsg>
        <BotMessage>
          <Loading />
          <img src={logoTransparent} alt="Logo" />
        </BotMessage>
      </ContainerBoxMsg>
    )
  }

  function renderPageRef(mensagemId) {
    return <div ref={pageEndRef} key={`ref-${mensagemId}`} />
  }

  return (
    <>
      <Wrapper>
        <Main isOpen={isOpen} className={`${isOpen ? '' : 'mainHide'}`}>
          <Header onClose={() => setIsOpen(false)} />

          <Body>
            <Content>{!conversation || conversation?.length === 0 ? renderLoading() : renderMessages()}</Content>

            <BoxInput
              sendMessage={sendMessage}
              sendMessageSelect={sendMessageSelect}
              msgIndex={values.msgIndex}
              tpServico={LoadTpServico()}
              URL_BASE={URL_BASE}
              laboratorioId={LoadLaboratorySelected()}
              conversation={conversation}
            />
          </Body>
        </Main>
      </Wrapper>

      <BtnChat onChange={() => setIsOpen(!isOpen)} isOpen={isOpen} />
    </>
  )
}
